export default {
  'database': [
    'csv'
  ],
  'markup': [
    'xml'
  ],  
  'script': ['json'],
  'text': ['txt'],
};
